import { render, staticRenderFns } from "./DeleiveryImages.vue?vue&type=template&id=f957cd26&scoped=true&"
import script from "./DeleiveryImages.vue?vue&type=script&lang=js&"
export * from "./DeleiveryImages.vue?vue&type=script&lang=js&"
import style0 from "./DeleiveryImages.vue?vue&type=style&index=0&id=f957cd26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f957cd26",
  null
  
)

export default component.exports